export const mailing = [
  {
    path: '/mailing',
    component: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/Mailing'),
    children: [
      {
        path: 'create',
        components: {
          body: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingEditBody'),
          bar: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingEditBar'),
        },
      },
      {
        path: ':id/edit',
        components: {
          body: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingEditBody'),
          bar: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingEditBar'),
        },
      },
      {
        path: ':id/recipients',
        components: {
          body: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingRecipientsBody'),
          bar: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingRecipientsBar'),
        }
      },
      {
        path: ':id/template',
        components: {
          body: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingTemplateBody'),
          bar: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingTemplateBar'),
        }
      },
      {
        path: ':id/attachments',
        components: {
          body: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingAttachmentsBody'),
          bar: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingAttachmentsBar'),
        }
      },
      {
        path: ':id/delivery',
        components: {
          body: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingDeliveryBody'),
          bar: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingDeliveryBar'),
        }
      },
      {
        path: ':id/tracking',
        components: {
          body: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingMessagesBody'),
          bar: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingMessagesBar'),
        },
      },
      {
        path: ':id/tracking/:message_id',
        components: {
          body: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingMessageBody'),
          bar: () => import(/* webpackChunkName: "mailing" */ '@/views/mailing/components/MailingMessageBar'),
        },
      },
    ]
  },
]
